import { Component } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
// import TimeAgo from 'javascript-time-ago'
// import en from 'javascript-time-ago/locale/en'
import { AppConfig } from './app.config';
// TimeAgo.addDefaultLocale(en)
declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  title = '';
  playstoreLink = '';
  showMobileDownloadPopup = '';
  imgWidth = '';
  imgHeight = '';
  showAppPopup = false;
  logo='';

  constructor(router: Router,private config: AppConfig) {
    this.title = this.config.getConfig('TITLE');
    this.playstoreLink = this.config.getConfig('MOBILE_PLAYSTORE_URL');
    this.showMobileDownloadPopup = this.config.getConfig('SHOW_MOBILE_APP_DOWNLOAD_POPUP');
    this.imgWidth = this.config.getConfig('LOGO_WIDTH');
    this.imgHeight = this.config.getConfig('LOGO_HEIGHT');
    this.logo = this.config.getConfig('LOGO');

    const navEndEvent$ = router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      gtag('config', 'UA-156741743-1', {'page_path':e.urlAfterRedirects});
      gtag('config', 'AW-701324529', {'page_path':e.urlAfterRedirects});

      if(e.url && e.url.indexOf('/instruction/') == -1 && pathName.indexOf('/analysis/') == -1 && e.url.indexOf('/test/') == -1 && e.url.indexOf('/specific-instruction/') == -1
      && e.url.indexOf('/quiz-test/') == -1 && e.url.indexOf('/practice-test/') == -1 && e.url.indexOf('/plans') == -1 && e.url.indexOf('/user-plans') == -1) {
      } else {
        this.showAppPopup = false;
      }
    });

    var x= document.getElementById("init-fcs");
    x.style.display = "none";
    var pathName =  window.location.pathname;
    if(screen.width <= 480 && pathName.indexOf('/instruction/') == -1 && pathName.indexOf('/analysis/') == -1 && pathName.indexOf('/test/') == -1 && pathName.indexOf('/specific-instruction/') == -1
      && pathName.indexOf('/quiz-test/') == -1 && pathName.indexOf('/practice-test/') == -1 && pathName.indexOf('/plans') == -1 && pathName.indexOf('/user-plans') == -1) {
      var userData = localStorage.getItem('userData');
      if(userData) {
        let  mt = localStorage.getItem('mob-popup-time');
        if(mt && new Date(new Date(mt).getTime() + 60 * 60 * 24 * 1000) < new Date()) {
          localStorage.setItem('mob-popup-time', new Date().toString());
        } else if(!mt) {
          this.showAppPopup = true;
          localStorage.setItem('mob-popup-time', new Date().toString());
        }
      }
    } else {
      this.showAppPopup = false;
    }
  }

  closeModal() {
    this.showAppPopup = false;
  }
}
